import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// PWA — Enregistre le service worker pour permettre l'installation sur l'écran
// d'accueil (« Ajouter à l'écran d'accueil ») et servir le shell hors-ligne.
// Non bloquant : silencieusement ignoré si le navigateur ne supporte pas.
if ("serviceWorker" in navigator && window.location.protocol === "https:") {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js", { scope: "/" }).catch(() => {
      // silencieux — pas de SW = expérience non-PWA normale, rien de cassé
    });
  });
}

